import React, { useEffect, useState } from "react";
import "./ServicesMianCard.css";
import {
  ADD_DOOR_STEP_CATEGORIES,
  CATEGORIES_TYPES,
  GET_DOOR_STEP_SUB_CATEGORY,
  UPDATE_DOOR_STEP_CATEGORIES,
} from "../../../URLs/Apis";
import AddIcon from "../../../assets/images/AddIcon.svg";
import noDataFound from "../../../assets/images/noDataFound.jpg";
import axios from "axios";
import Edit from "../../../assets/svg/EdateSubCategory.svg";
import ArrUp from "../../../assets/svg/ArrUp.svg";
import Trash from "../../../assets/svg/trash-bin.svg";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  ListItemText,
  MenuItem,
  Select,
  Switch,
} from "@mui/material";
import CameraIcon from "../../../assets/svg/CameraIcon.svg";
import { Button, Form, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { TextField } from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteModal from "../../../components/Modals/DeleteModal.jsx";
import {
  Delete,
  LocationOn,
  MoreVert,
  ModeEdit,
  Add,
} from "@mui/icons-material";

function ServicesMainCard() {
  const typesToShow = [
    {
      label: "Card",
      value: "Card",
    },
    {
      label: "Dropdown",
      value: "Dropdown",
    },
    {
      label: "Checkbox",
      value: "Checkbox",
    },
    {
      label: "Radio",
      value: "Radio",
    },
  ];

  const [subCategoryImages, setSubCategoryImages] = useState([]);

  const [removedImages, setRemovedImages] = useState([]);

  const navigate = useNavigate();

  const { id } = useParams();

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  // add , update & delete subCategory

  const [show, setShow] = useState(false);

  const [subCategoryImage, setSubCategoryImage] = useState(null);

  const handleShow = () => {
    setIsSubEdit(false);
    setShow(true);
    setSubCategoryImages([]);
    reset();
  };

  const handleClose = () => {
    reset();
    setSubCategoryImage(null);
    setShow(false);
  };

  const [categoryTypes, setCategoryTypes] = useState([]);

  const [subCategoryById, setSubCategoryById] = useState({});

  const [isSubEdit, setIsSubEdit] = useState(false);

  const [updateSubCategory, setUpdateSubCategory] = useState({
    parent_id: id,
    name: subCategoryById?.name || "",
    description: subCategoryById?.description || "",
    status: subCategoryById?.status || "",
    slug: subCategoryById?.slug || "",
    background_color: subCategoryById?.background_color || "",
    type_id: subCategoryById?.type_id || "",
    order: subCategoryById?.order || "",
    show_as: subCategoryById?.show_as || "",
    icon_url:
      `https://estbn.com/EstbnNew/public/${subCategoryById?.icon_url}` || "",
  });

  const {
    register: subCategoryRegister,
    handleSubmit: handleSubmitSubCategory,
    setValue,
    control,
    reset,
    formState: { errors: subCategoryErrors },
  } = useForm({
    defaultValues: {
      name: "",
      background_color: "",
      slug: "",
      order: "",
      type_id: null,
      status: "",
      description: "",
      parent_id: id,
      show_as: "",
      icon_url: null,
    },
  });

  const onSubmit = (formData) => {
    console.log("data", formData);

    const fullData = new FormData();

    Object.keys(formData).forEach((key) => {
      if (key === "icon_url") {
        if (formData[key] instanceof File) {
          fullData.append("icon_url", formData[key]);
        }
      } else {
        if (formData[key] !== undefined) {
          fullData.append(key, formData[key]);
        }
      }
    });

    subCategoryImages.forEach((img, index) => {
      if (!img.isFromBackend && img.file) {
        fullData.append(`images[${index}][image]`, img.file);
      }
    });

    removedImages.forEach((id) => {
      fullData.append("remove_images[]", id);
    });

    if (isSubEdit) {
      fullData.append("_method", "PUT");
      axios
        .post(`${UPDATE_DOOR_STEP_CATEGORIES}${subCategoryId}`, fullData, {
          headers: { Authorization: `Bearer ${user?.token}` },
        })
        .then((res) => {
          toast.success("Subcategory updated!");
          getCategoryData();
          setShow(false);
          setSubCategoryImages([]);
          setRemovedImages([]);
        });
    } else {
      axios
        .post(ADD_DOOR_STEP_CATEGORIES, fullData, {
          headers: { Authorization: `Bearer ${user?.token}` },
        })
        .then((res) => {
          toast.success("Subcategory added!");
          getCategoryData();
          setShow(false);
          setSubCategoryImage(null);
          setSubCategoryImages([]);
        });
    }
  };

  const FileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setSubCategoryImage(reader.result);
        setValue("icon_url", file);
      };
      reader.readAsDataURL(file);
    }
  };

  const [subCategoryId, setSubCategoryId] = useState("");

  const handleEditSubCategory = async (subCategory) => {
    console.log(subCategory);
    setIsSubEdit(true);
    setShow(true);
    setRemovedImages([]);
    setSubCategoryId(subCategory.id);

    setUpdateSubCategory({
      ...updateSubCategory,
      name: subCategory.name,
      description: subCategory.description,
      status: subCategory.status,
      slug: subCategory.slug,
      background_color: subCategory.background_color,
      type_id: subCategory.type_id,
      order: subCategory.order,
      show_as: subCategory.show_as,
      icon_url: `https://estbn.com/EstbnNew/public/${subCategory.icon_url}`,
    });

    setSubCategoryImage(
      subCategory.icon_url
        ? `https://estbn.com/EstbnNew/public/${subCategory.icon_url}`
        : null
    );
    setValue("icon_url", null);

    const existingImgs =
      subCategory.images?.map((img) => ({
        id: img.id,
        preview: img.image_url.startsWith("http")
          ? img.image_url
          : `https://estbn.com/EstbnNew/public/${img.image_url}`,
        file: null,
        isFromBackend: true,
      })) || [];
    setSubCategoryImages(existingImgs);

    if (isSubEdit) {
      try {
        const response = await axios.get(
          `${GET_DOOR_STEP_SUB_CATEGORY}/${subCategory.id}`,
          { headers }
        );
        console.log("services", response);
        const data = response?.data?.data?.category;
        setSubCategoryById(data);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const confirmSubDelete = () => {
    setShowSubDelete(true);
  };

  const handleSubDeleteClose = () => {
    setShowSubDelete(false);
  };

  const handleDeleteSubCatgory = async () => {
    try {
      const response = await axios.delete(
        `${UPDATE_DOOR_STEP_CATEGORIES}${subCategoryId}`,
        { headers }
      );
      console.log("services", response);
      getCategoryData();
      toast.success(response.data.data.message);
      setShow(false);
      setShowSubDelete(false);
    } catch (error) {
      console.log(error);
    }
  };

  // **********************

  const [dataServecsSubCategory, setGetDataServecesSubCategory] =
    useState(null);

  const [TheOneToShowMore, setTheOneToShowMore] = useState(null);

  const [showDelete, setShowDelete] = useState(false);

  const [showSubDelete, setShowSubDelete] = useState(false);

  const fetchServiceCategoryTypes = () => {
    const headers = {
      Authorization: "Bearer " + user?.token,
    };

    axios
      .get(CATEGORIES_TYPES, { headers })
      .then((response) => {
        console.log(response);

        setCategoryTypes(response.data.data.service_category_types);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const fetchServicesForCategory = async (categoryId) => {
    try {
      setGetDataServecesSubCategory(null);
      const data = await axios.get(
        `${newBaseUrl}/api/portal/door_step_services?category_id=${categoryId}`,
        { headers }
      );
      console.log(data?.data?.data?.services);
      setGetDataServecesSubCategory(data?.data?.data?.services || []);
    } catch (error) {
      console.log(error?.response?.data || error);
    }
  };

  const toggleAccordion = async (categoryId) => {
    if (TheOneToShowMore === categoryId) {
      setTheOneToShowMore(null);
      return;
    }
    await fetchServicesForCategory(categoryId);
    setTheOneToShowMore(categoryId);
  };

  const ensureOpenAndRefresh = async (categoryId) => {
    if (!categoryId) return;
    await fetchServicesForCategory(categoryId);
    setTheOneToShowMore(categoryId);
    setTimeout(() => {
      document
        .getElementById(`accordion-${categoryId}`)
        ?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 100);
  };

  // service actions

  const [name, setName] = useState("");

  const [price, setPrice] = useState("");

  const [required, setRequired] = useState(false);

  const [inOffer, setInOffer] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const [selectedServiceId, setSelectedServiceId] = useState(null);

  const [estimatedMinutes, setEstimatedMinutes] = useState("");

  const [isEdit, setIsEdit] = useState(false);

  const handleDeleteClose = () => {
    setShowDelete(false);
    setSelectedServiceId(null);
    handleClose();
  };

  const confirmDelete = (id) => {
    setSelectedServiceId(id);
    if (!selectedCategoryId && TheOneToShowMore) {
      setSelectedCategoryId(TheOneToShowMore);
    }
    setShowDelete(true);
  };

  const openModal = (categoryId) => {
    setSelectedCategoryId(categoryId);
    setIsEdit(false);
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEstimatedMinutes("");
    setPrice("");
    setRequired(false);
    setInOffer(false);
    setSelectedEquipments([]);
    setSelectedProducts([]);
  };

  const handleUpdateService = (data) => {
    console.log(data);
    setIsEdit(true);
    setSelectedServiceId(data.id);
    setSelectedCategoryId(TheOneToShowMore || selectedCategoryId);
    setName(data.name);
    setEstimatedMinutes(data.estimated_time);
    setPrice(data.price);
    setRequired(data.is_required === false ? false : true);
    setInOffer(data.offer_only === "0" ? false : true);

    if (data.products && Array.isArray(data.products)) {
      const productIds = data.products.map((p) => p.id);
      setSelectedProducts(productIds);
    } else {
      setSelectedProducts([]);
    }

    if (data.equipment_models && Array.isArray(data.equipment_models)) {
      const equipmentIds = data.equipment_models.map((eq) => eq.id);
      setSelectedEquipments(equipmentIds);
    } else {
      setSelectedEquipments([]);
    }

    setShowModal(true);
  };

  const handleAddSubmit = async (data) => {
    const formData = new FormData();

    if (isEdit) formData.append("_method", "PATCH");
    if (!isEdit)
      formData.append("door_step_service_category_id", selectedCategoryId);

    formData.append("estimated_time", estimatedMinutes.toString());
    formData.append("name", name);
    formData.append("price", price);
    formData.append("status", "active");

    formData.append("is_required", required ? 1 : 0);
    formData.append("offer_only", inOffer ? 1 : 0);

    selectedProducts.forEach((productId, index) => {
      formData.append(`products[${index}]`, productId);
    });

    selectedEquipments.forEach((equipId, index) => {
      formData.append(`equipment_models[${index}][id]`, equipId);
    });

    try {
      const response = await axios.post(
        isEdit
          ? `https://estbn.com/EstbnNew/public/api/portal/door_step_services/${selectedServiceId}`
          : "https://estbn.com/EstbnNew/public/api/portal/door_step_services",
        formData,
        { headers }
      );

      console.log("Service added:", response.data);
      toast.success(
        isEdit ? "Service Updated Successfully" : "Service Added Successfully",
        { autoClose: 3000 }
      );

      const targetCatId =
        selectedCategoryId || TheOneToShowMore || subCategoryId;
      await ensureOpenAndRefresh(targetCatId);
      closeModal();
    } catch (error) {
      if (error.response) {
        toast.error(error.response.data.message, { autoClose: 3000 });
        console.error("Error response:", error.response.data);
      } else {
        console.error("Submission error:", error.message);
        alert(`Submission failed: ${error.message}`);
      }
    }
  };

  const deleteService = async () => {
    try {
      let response = await axios.delete(
        `https://estbn.com/EstbnNew/public/api/portal/door_step_services/${selectedServiceId}`,
        {
          headers,
        }
      );
      toast.warning("Service Deleted successfully", { autoClose: 3000 });
      console.log(response);
      const targetCatId =
        selectedCategoryId || TheOneToShowMore || subCategoryId;
      await ensureOpenAndRefresh(targetCatId);
      handleDeleteClose();
    } catch (error) {
      toast.error("Failed To Delete This Service.");
      console.log(error.message);
    }
  };

  // edits from mostafa

  const [categoryData, setCategoryData] = useState(null);

  const [subCategoryData, setSubCategoryData] = useState([]);

  const [products, setProducts] = useState([]);

  const [selectedProducts, setSelectedProducts] = useState([]);

  const [equipmentModels, setEquipmentModels] = useState([]);

  const [selectedEquipments, setSelectedEquipments] = useState([]);

  const getProducts = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/product_variations`,
        { headers }
      );
      console.log(response.data.data.variations);
      setProducts(response.data.data.variations);
    } catch (error) {
      console.log(error);
    }
  };

  const getEquipmentModels = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/equipment-models`,
        { headers }
      );
      setEquipmentModels(response.data.data.equipment_models);
    } catch (error) {
      console.log(error);
    }
  };

  const getCategoryData = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/doorstep-service-categories/${id}`,
        { headers }
      );
      console.log(response.data.data);

      const mainCat = response.data.data.main_category;
      const subCats = response.data.data.subcategories;

      setCategoryData(mainCat);
      setSubCategoryData(subCats);
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange_AddOrder = (id, currentStatus) => {
    const newStatus = currentStatus === "active" ? "inactive" : "active";
    axios
      .post(
        `https://estbn.com/EstbnNew/public/api/service_categories/${id}`,
        { status: newStatus },
        { headers }
      )
      .then(() => {
        getCategoryData();
      })
      .catch((err) => console.error("Update failed:", err));
  };

  useEffect(() => {
    getCategoryData();
  }, [id]);

  useEffect(() => {
    fetchServiceCategoryTypes();
    getProducts();
    getEquipmentModels();
  }, []);

  useEffect(() => {
    if (isSubEdit && updateSubCategory) {
      reset({
        name: updateSubCategory.name,
        background_color: updateSubCategory.background_color,
        slug: updateSubCategory.slug,
        order: updateSubCategory.order,
        type_id: updateSubCategory.type_id,
        status: updateSubCategory.status,
        description: updateSubCategory.description,
        parent_id: updateSubCategory.parent_id,
        icon_url: updateSubCategory.icon_url,
      });
      if (typeof updateSubCategory.icon_url === "string") {
        setSubCategoryImage(updateSubCategory.icon_url);
      }
    } else {
      reset({
        name: "",
        background_color: "",
        slug: "",
        order: "",
        type_id: "",
        status: "",
        description: "",
        parent_id: id,
        icon_url: null,
      });
      setSubCategoryImage(null);
    }
  }, [isSubEdit, updateSubCategory]);

  return (
    <>
      {/* add & update service modal  */}
      <Modal show={showModal} onHide={closeModal} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>
            {isEdit ? "Update Service" : "Add New Service"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* name */}
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Service Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="add-service-input"
              />
            </Form.Group>
            {/* products */}
            <div className="row">
              <div className="col-sm-12 ">
                <Controller
                  name="products"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <FormControl className="w-100 mb-3" variant="outlined">
                      <InputLabel id="products-label">Products</InputLabel>
                      <Select
                        labelId="products-label"
                        label="Products"
                        multiple
                        value={selectedProducts}
                        onChange={(e) => {
                          const selectedOptions = e.target.value;
                          setSelectedProducts(selectedOptions);
                          field.onChange(selectedOptions);
                        }}
                        renderValue={(selected) =>
                          products
                            .filter((p) => selected.includes(p.id))
                            .map((p) => p.sku)
                            .join(", ")
                        }
                      >
                        {products.map((pro) => (
                          <MenuItem key={pro.id} value={pro.id}>
                            <Checkbox
                              checked={selectedProducts.includes(pro.id)}
                            />
                            <ListItemText primary={pro.sku} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
              </div>
            </div>
            {/* Equipments */}
            <div className="row">
              <div className="col-sm-12 ">
                <Controller
                  name="Equipments"
                  control={control}
                  defaultValue={[]}
                  render={({ field }) => (
                    <FormControl className="w-100 mb-3" variant="outlined">
                      <InputLabel id="Equipments-label">Equipments</InputLabel>
                      <Select
                        labelId="Equipments-label"
                        label="Equipments"
                        multiple
                        value={selectedEquipments}
                        onChange={(e) => {
                          const selectedOptions = e.target.value;
                          setSelectedEquipments(selectedOptions);
                          field.onChange(selectedOptions);
                        }}
                        renderValue={(selected) =>
                          equipmentModels
                            .filter((e) => selected.includes(e.id))
                            .map((e) => e.name)
                            .join(", ")
                        }
                      >
                        {equipmentModels.map((eq) => (
                          <MenuItem key={eq.id} value={eq.id}>
                            <Checkbox
                              checked={selectedEquipments.includes(eq.id)}
                            />
                            <ListItemText primary={eq.name} />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
              </div>
            </div>
            {/* estimated time */}
            <Form.Group className="mb-3">
              <Form.Control
                type="number"
                min="0"
                placeholder="Estimated Time (minutes)"
                value={estimatedMinutes}
                onChange={(e) => setEstimatedMinutes(e.target.value)}
                className="add-service-input"
              />
            </Form.Group>
            {/* price */}
            <Form.Group className="mb-3">
              <Form.Control
                type="number"
                placeholder="Price"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="add-service-input"
              />
            </Form.Group>
            {/* checks */}
            <div className="d-flex justify-content-between">
              <Form.Check
                type="checkbox"
                label="Required"
                checked={required}
                onChange={(e) => setRequired(e.target.checked)}
              />
              <Form.Check
                type="checkbox"
                label="In Offer"
                checked={inOffer}
                onChange={(e) => setInOffer(e.target.checked)}
              />
            </div>
          </Form>
        </Modal.Body>
        {/* footer */}
        <Modal.Footer className="modal-footer-centered">
          <Button className="submit-btn" onClick={handleAddSubmit}>
            Submit
          </Button>
          <Button variant="secondary" onClick={closeModal}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
      {/* delete service modal */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this service?"}
        deleteFunction={deleteService}
      />
      {/* delete subCategory modal  */}
      <DeleteModal
        showDelete={showSubDelete}
        handleDeleteClose={handleSubDeleteClose}
        textMessage={" Are you sure you want to delete this sub category?"}
        deleteFunction={handleDeleteSubCatgory}
      />
      {/* add & update sub category */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="AddStaffModal_header">
          <Modal.Title className="AddStaffModal_title d-flex justify-content-between align-items-center w-100">
            {isSubEdit ? "Edit Sub Category" : "Add New Sub Category"}
            {isSubEdit ? (
              <div onClick={confirmSubDelete}>
                <Delete color="error" />
              </div>
            ) : (
              ""
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmitSubCategory(onSubmit)}>
            {/* image */}
            <div className="flex-center-x-y">
              <div>
                <label htmlFor="category-img" className="addstaff_photo">
                  {subCategoryImage ? (
                    <img
                      className="photoStyle_addMember"
                      src={subCategoryImage}
                      alt="Preview"
                    />
                  ) : (
                    <img src={CameraIcon} alt="" />
                  )}
                </label>
                <input
                  id="category-img"
                  className="d-none"
                  type="file"
                  onChange={FileChange}
                />
              </div>
            </div>
            {/* name & background */}
            <div className="row">
              {/* name */}
              <div className="col-md-6 col-sm-12">
                <TextField
                  className="w-100 mb-4"
                  label="Category Name"
                  {...subCategoryRegister("name")}
                />
              </div>
              {/* background */}
              <div className="col-md-6 col-sm-12">
                <TextField
                  className="w-100 mb-4"
                  label="Sub Category Background"
                  variant="outlined"
                  placeholder="#535353"
                  {...subCategoryRegister("background_color")}
                />
              </div>
            </div>
            {/* type & status */}
            <div className="row">
              {/* type */}
              <div className="col-md-6 col-sm-12 ">
                <Controller
                  name="type_id"
                  control={control}
                  render={({ field }) => (
                    <FormControl className="w-100 mb-4" variant="outlined">
                      <InputLabel id="type-label">Sub Category Type</InputLabel>
                      <Select
                        labelId="type-label"
                        label="Sub Category Type"
                        value={field.value || ""}
                        onChange={(e) => field.onChange(e.target.value)}
                      >
                        {categoryTypes.map((type) => (
                          <MenuItem
                            key={type.id}
                            value={type.id}
                            className="custom-menu-item"
                          >
                            {type.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
              </div>
              {/* status */}
              <div className="col-md-6 col-sm-12 ">
                <Controller
                  name="status"
                  control={control}
                  defaultValue={isSubEdit ? updateSubCategory.status : ""}
                  render={({ field }) => (
                    <FormControl className="w-100 mb-4" variant="outlined">
                      <InputLabel id="status-label">Status</InputLabel>
                      <Select labelId="status-label" label="Status" {...field}>
                        <MenuItem value="active" className="custom-menu-item">
                          Active
                        </MenuItem>
                        <MenuItem value="inactive" className="custom-menu-item">
                          Inactive
                        </MenuItem>
                      </Select>
                    </FormControl>
                  )}
                />
                {subCategoryErrors.status && (
                  <p className="danger">{subCategoryErrors.status.message}</p>
                )}
              </div>
            </div>
            {/* order & slug */}
            <div className="row">
              {/* order */}
              <div className="col-md-6 col-sm-12">
                <TextField
                  type="number"
                  className="w-100 mb-4"
                  label="Sub Category Order"
                  placeholder="Enter the Value of Order"
                  variant="outlined"
                  {...subCategoryRegister("order")}
                />
              </div>
              {/* slug */}
              <div className="col-md-6 col-sm-12">
                <TextField
                  className="w-100 mb-4"
                  label="Sub Category Slug"
                  variant="outlined"
                  placeholder="Enter the Value of Slug"
                  {...subCategoryRegister("slug")}
                />
              </div>
            </div>
            {/* show as */}
            <div className="row">
              {/* types to show */}
              <div className="col-sm-12 ">
                <Controller
                  name="show_as"
                  control={control}
                  // defaultValue={isSubEdit ? updateSubCategory.status : ""}
                  render={({ field }) => (
                    <FormControl className="w-100 mb-4" variant="outlined">
                      <InputLabel id="show-label">Show As</InputLabel>
                      <Select labelId="show-label" label="show_as" {...field}>
                        {typesToShow.map((ty) => (
                          <MenuItem
                            className="custom-menu-item"
                            value={ty.value}
                          >
                            {ty.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  )}
                />
                {subCategoryErrors.status && (
                  <p className="danger">{subCategoryErrors.status.message}</p>
                )}
              </div>
            </div>
            {/* description */}
            <TextField
              className="w-100 mb-4"
              label="Category Description"
              placeholder="Add Category Description"
              variant="outlined"
              rows={4}
              multiline
              {...subCategoryRegister("description")}
            />
            {/* Multi Images Section */}
            <div className="mb-4">
              <div className="d-flex justify-content-between align-items-center">
                <label className="form-label fw-bold">Gallery Images</label>
                <input
                  type="file"
                  id="subcategoryGallery"
                  accept="image/*"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => {
                    const selectedFiles = Array.from(e.target.files);
                    const validFiles = selectedFiles.filter((file) =>
                      [
                        "image/jpeg",
                        "image/png",
                        "image/jpg",
                        "image/gif",
                        "image/svg+xml",
                      ].includes(file.type)
                    );

                    if (validFiles.length !== selectedFiles.length) {
                      toast.error(
                        "Some files were skipped (invalid image types)"
                      );
                    }

                    const newImgs = validFiles.map((file) => ({
                      file,
                      preview: URL.createObjectURL(file),
                      isFromBackend: false,
                    }));

                    setSubCategoryImages((prev) => [...prev, ...newImgs]);
                  }}
                />

                <label
                  htmlFor="subcategoryGallery"
                  className="btn btn-light d-flex align-items-center gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <i className="bi bi-upload" style={{ fontSize: "1rem" }}></i>
                  Add Images
                </label>
              </div>

              {/* Image previews */}
              <div className="d-flex justify-content-evenly align-items-center flex-wrap gap-2 mt-3">
                {subCategoryImages.map((img, index) => (
                  <div
                    key={index}
                    className="position-relative d-flex justify-content-center align-items-center my-1"
                    style={{
                      width: "22%",
                      borderRadius: "10px",
                      border: "1px solid #ccc",
                      boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                      height: "100px",
                    }}
                  >
                    <img
                      src={img.preview}
                      alt={`preview-${index}`}
                      style={{
                        width: "90%",
                        height: "100px",
                        objectFit: "contain",
                      }}
                    />
                    <button
                      type="button"
                      // onClick={() =>
                      //   setSubCategoryImages((prev) =>
                      //     prev.filter((_, i) => i !== index)
                      //   )
                      // }
                      onClick={() => {
                        setSubCategoryImages((prev) => {
                          const removed = prev[index];
                          // لو الصورة جاية من الباك اند، خزّن الـ id بتاعها
                          if (removed.isFromBackend) {
                            setRemovedImages((old) => [...old, removed.id]);
                          }
                          return prev.filter((_, i) => i !== index);
                        });
                      }}
                      style={{
                        position: "absolute",
                        top: "-10px",
                        right: "-10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#ff4d4d",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50%",
                        width: "22px",
                        height: "22px",
                        cursor: "pointer",
                      }}
                    >
                      x
                    </button>
                  </div>
                ))}
              </div>
            </div>
            {/* footer */}
            <div className="foterAddModel">
              <button
                type="button"
                className="closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                // type="submit"
                // disabled={isSubmitting}
                className="saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* head of the data */}
      <div className="titleOfServicesPage mx-4">
        <div className="titleOfServicesPage_title">
          <img
            className="mx-2"
            src={"https://estbn.com/EstbnNew/public" + categoryData?.icon_url}
            alt={categoryData?.slug}
          />
          <span>{categoryData?.name}</span>
        </div>
        <div
          className="staff-header_edete-icon mainBorder d-flex mx-3"
          onClick={handleShow}
        >
          <img src={AddIcon} alt="" />
          <span className="d-flex">Add Sub Category</span>
        </div>
      </div>
      {/* subcategories data */}
      <div className="DataMainCard">
        {subCategoryData ? (
          subCategoryData.map((e) => {
            return (
              <>
                <div
                  key={e.id}
                  id={`accordion-${e.id}`}
                  className="accordion-item w-100 mb-4"
                >
                  <h2 className="accordion-header subCatogeryServis">
                    <div
                      style={{ borderRadius: "10px" }}
                      className={`accordion-button  bg-light text-dark btn-xs buttons`}
                    >
                      <div className="row textdataSubCategory">
                        {/* name & icon  */}
                        <div className="col-8" style={{ paddingLeft: "30px" }}>
                          <FormControlLabel
                            key={e.id}
                            control={
                              <Switch
                                checked={e.status === "active"}
                                onChange={() =>
                                  handleChange_AddOrder(e.id, e.status)
                                }
                                onClick={(e) => e.stopPropagation()}
                              />
                            }
                            label=""
                          />
                          <img
                            src={
                              "https://estbn.com/EstbnNew/public" + e.icon_url
                            }
                            alt={e.slug}
                            className="icon_subCatogeryServis"
                          />
                          {e.name}
                        </div>
                        {/* icons for actions  */}
                        <div className="col-4 rgithSideOfTitleSubCategory position-relative">
                          <div className="dropdown">
                            <button
                              className="btn p-0 border-0 bg-transparent"
                              type="button"
                              id={`dropdownMenuButton-${e.id}`}
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <MoreVert
                                style={{ fontSize: "20px", color: "#000" }}
                              />
                            </button>
                            <ul
                              className="dropdown-menu dropdown-menu-end shadow-sm"
                              aria-labelledby={`dropdownMenuButton-${e.id}`}
                              style={{
                                borderRadius: "10px",
                                minWidth: "180px",
                                backgroundColor: "#C6C6C6",
                              }}
                            >
                              <li>
                                <button
                                  className="btn d-flex align-items-center py-2 gap-2 w-100"
                                  onClick={() => openModal(e.id)}
                                >
                                  <Add fontSize="small" />
                                  Add Services
                                </button>
                              </li>
                              <li>
                                <button
                                  className="btn d-flex align-items-center py-2 gap-2 w-100"
                                  onClick={() => handleEditSubCategory(e)}
                                >
                                  <ModeEdit fontSize="small" />
                                  Edit
                                </button>
                              </li>
                              <li>
                                <button
                                  className="btn d-flex align-items-center py-2 gap-2 w-100"
                                  onClick={() =>
                                    navigate(`/services/${e.id}/Pervisit`)
                                  }
                                >
                                  <LocationOn fontSize="small" />
                                  On-site Pricing
                                </button>
                              </li>
                            </ul>
                          </div>
                          <button
                            type="button"
                            onClick={() => {
                              setSelectedCategoryId(e.id);
                              toggleAccordion(e.id);
                            }}
                            className="btn p-0 border-0 bg-transparent"
                          >
                            <img
                              src={ArrUp}
                              className={`${
                                TheOneToShowMore !== e.id ? "rotate180" : ""
                              } transtion-movement ps-2 pe-2`}
                              alt="arrow"
                            />
                          </button>
                        </div>

                        {/* <div className="col-4 rgithSideOfTitleSubCategory"> 
                          <bottom type="button" onClick={() => openModal(e.id)}>
                            <img
                              src={AddIcon}
                              className={`ps-2 pe-2`}
                              alt="trash-bin"
                            />
                          </bottom>
                          <bottom
                            type="button"
                            onClick={() => handleEditSubCategory(e)}
                          >
                            <img
                              src={Edit}
                              className={`ps-2 pe-2`}
                              alt="trash-bin"
                            />
                          </bottom>
                          <bottom
                            type="button"
                            onClick={() => {
                              setSelectedCategoryId(e.id);
                              toggleAccordion(e.id);
                            }}
                          >
                            <img
                              src={ArrUp}
                              className={`${
                                TheOneToShowMore !== e.id ? "rotate180" : ""
                              } transtion-movement ps-2 pe-2`}
                              alt="trash-bin"
                            />
                          </bottom>
                        </div> */}
                      </div>
                    </div>
                  </h2>
                  <div
                    style={{ padding: "0 15px" }}
                    className={`subCategoryDate ${
                      TheOneToShowMore === e.id ? "" : "d-none"
                    }`}
                  >
                    {dataServecsSubCategory?.map((j) => {
                      return (
                        <div>
                          <div className="subCategoryServese" key={j.id}>
                            <div className="leftSide_subCategoryServese">
                              {j.name}
                            </div>
                            <div className="rightSide_subCategoryServese">
                              {j.price}
                              <bottom
                                type="button"
                                onClick={() => handleUpdateService(j)}
                              >
                                <img
                                  src={Edit}
                                  className={`ps-2 pe-2`}
                                  alt="trash-bin"
                                />
                              </bottom>
                              <bottom
                                type="button"
                                onClick={() => confirmDelete(j.id)}
                              >
                                <img
                                  src={Trash}
                                  className={`ps-2 pe-2`}
                                  alt="trash-bin"
                                />
                              </bottom>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </>
            );
          })
        ) : (
          <div className="noDataMainCard">
            <img
              className="imgForNoDataMainCard"
              src={noDataFound}
              alt="No staff members"
            />
            <p className="textForNoDataMainCard">
              Oil and Filter list is empty. Add Services to keep everything
              organized.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default ServicesMainCard;
